import { z } from 'zod';

export const cardReferenceRegionSchema = z
  .object({
    left: z.number().min(0).max(1),
    top: z.number().min(0).max(1),
    width: z.number().gt(0).max(1),
    height: z.number().gt(0).max(1),
  })
  .strict()
  .superRefine((region, context) => {
    if (region.left + region.width > 1)
      context.addIssue({
        code: 'custom',
        message: 'Region exceeds page width',
      });
    if (region.top + region.height > 1)
      context.addIssue({
        code: 'custom',
        message: 'Region exceeds page height',
      });
  });

export type CardReferenceRegion = z.infer<typeof cardReferenceRegionSchema>;
